import * as R from 'ramda';

export default function EditITCoreProceduresDialogController(
  $rootScope,
  $scope,

  loaderService,
  ssDialogService,
  bcpDataService,
  alerts
) {
  const vm = this;

  vm.newAssessmentItCoreProcedures = R.clone(vm.assessmentItCoreProcedures);

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleFormSubmit = _handleFormSubmit;

  /** ************************************************
   * Event Handlers
   */


  function _handleCloseDialogClick() {
    _closeDialog();
  }


  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.editITCoreProceduresDialog);
  }

  function _handleFormSubmit() {
    loaderService.showGlobalLoader = true;
    if ($scope.editITCoreProceduresForm.$valid) {
      bcpDataService.saveITCoreProcedures(
        vm.newAssessmentItCoreProcedures
      ).then((saveITCoreProceduresResponse) => {
        angular.extend(vm.assessmentItCoreProcedures, saveITCoreProceduresResponse.data);
        $rootScope.$broadcast('refreshStatuses');
        alerts.success('The IT/Core Procedures texts have been successfully saved.');
        loaderService.showGlobalLoader = false;
        if (vm.saveType === 'saveAndClose') {
          _closeDialog();
        }
      });
    }
  }
}

EditITCoreProceduresDialogController.$inject = [
  '$rootScope',
  '$scope',

  'loaderService',
  'ssDialogService',
  'bcpDataService',
  'alerts',
];
